import { ToolbarButton as e } from "./toolbar-button.mjs";
import { ToolbarSheetRow as t } from "./toolbar-sheet-row.mjs";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/content-controls/toolbar-action-item.tsx
function r({ active: r, disabled: i, icon: a, label: o, onClick: s, tooltip: c }) {
	return {
		toolbarRender: /* @__PURE__ */ n(e, {
			active: r,
			disabled: i,
			label: o,
			onClick: s,
			tooltip: c,
			children: a
		}),
		sheetRender: /* @__PURE__ */ n(t, {
			active: r,
			disabled: i,
			icon: a,
			label: o,
			onClick: s
		})
	};
}
//#endregion
export { r as toolbarActionItem };
